import React from "react";
import { Layout } from "antd";

import HeaderMenu from "../../HeaderMenu/HeaderMenu";
import BatchTable from "./BatchTable";
import { PageHeader } from "@ant-design/pro-layout";

const { Content } = Layout;

const BatchTablePage = () => {
  return (
    <>
      <HeaderMenu>
        <PageHeader title={<h1>Batches</h1>} />
      </HeaderMenu>

      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <BatchTable />
      </Content>
    </>
  );
};

export default BatchTablePage;
